module.exports = __webpack_public_path__ + "img/Monolithic_vs_Microservices_Architectures.76557b55.jpeg";